export const uk = {
    'invalid-query': 'В фразе содержатся запрещенные символы. Допустимы только буквы, цифры и операторы Директа',
    'no-phrases-for-dynamic-campaigns': 'Нельзя добавлять фразы в группы Динамических кампаний',
    'no-phrases-for-smart-banners': 'Нельзя добавлять фразы в Смарт-баннерах'
};
